/* eslint-disable max-len */
/* eslint-disable quotes */
import React from "react";
import { useNavigate } from "react-router-dom";
import { AvatarCustom } from "../../../components";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { format } from "date-fns";
import { PAGES_PATH } from "../../../navigation/params";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";

interface IWellnessRenewalUnsuccessfulCard {
  currentDate: number;
  startDate: number;
  petId: string;
  petImage?: string;
  petName: string;
  planName: string;
  isScratchpay?: boolean;
}

const WellnessRenewalUnsuccessfulCard: React.FC<IWellnessRenewalUnsuccessfulCard> = ({
  currentDate,
  startDate,
  petId,
  petImage,
  petName,
  planName,
  isScratchpay = false,
}) => {
  const navigate = useNavigate();

  const getDateInUTC = (epochSeconds: number) => {
    const date = new Date(epochSeconds * 1000);

    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  };

  const getAlertCardHeading = () => {
    const current = getDateInUTC(currentDate);
    const start = getDateInUTC(startDate);

    const dayDifference = Math.floor((current.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

    switch (dayDifference) {
    case 0:
    case 1:
      return `We couldn’t renew ${petName}’s GoodPet+ Plan`;
    case 2:
      return `${petName}'s Wellness Plan renewal failed.`;
    default:
      return `We couldn’t renew ${petName}’s GoodPet+ Plan`;
    }
  };

  const getAlertCardSubText = () => {
    const current = getDateInUTC(currentDate);
    const start = getDateInUTC(startDate);

    const dayDifference = Math.floor((current.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

    const formatDate = (date: Date) => format(date, "MMMM d, yyyy");

    switch (dayDifference) {
    case 0:
    case 1: {
      const deadline = new Date(start);

      deadline.setDate(deadline.getDate() + 2);

      return `Payment failed when trying to renew your plan. Update your payment method by ${formatDate(
        deadline)} to renew your plan.`;
    }
    case 2:
      return `Payment failed when trying to renew your plan. Update your payment method today to renew your plan.`;
    default:
      return "Payment failed when trying to renew your plan. Update your payment method today to renew your plan.";
    }
  };

  const handleAlertCardCtaClick = () => {
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_UPDATE_PAYMENT_FROM_DASHBOARD,
      { pet_id: petId,
        pet_name: petName,
        plan_name: planName,
        is_scratchpay: isScratchpay,
        payment_processor: isScratchpay ? "scratchpay" : "square",
        card_type: "renewal_unsuccessful_grace_period",
        entry_point: "dashboard",
      });
    navigate(`${PAGES_PATH.MANAGE_PLAN}?id=${petId}`);
  };

  return (
    <div className="bg-gray-3 px-4 py-6 rounded-xl">
      <div className="rounded-xl bg-white flex flex-col p-4 pt-3 gap-3 shadow-lg">
        <div
          className={`text-center text-sm font-semibold text-white bg-red-4 rounded py-0.5 mb-[-0.2rem]`}
        >
          Renewal Unsuccessful
        </div>
        <div className="flex gap-3 w-full items-center justify-center">
          <div className="flex items-center">
            <AvatarCustom
              width={70}
              height={70}
              image={petImage}
              name={petName}
              isPlanOverdue={true}
            />
          </div>
          <div className="flex flex-col justify-center pb-3 h-full">
            <div className="font-semibold">
              <div>{getAlertCardHeading()}</div>
            </div>
            <div className="text-sm text-justify">{getAlertCardSubText()}</div>
          </div>
        </div>
        <div>
          <StyledBookingFlowButton
            disabled={false}
            fullWidth
            color="primary"
            size="small"
            onClick={() => handleAlertCardCtaClick()}
          >
            Update Payment Method
          </StyledBookingFlowButton>
        </div>
      </div>
    </div>
  );
};

export default WellnessRenewalUnsuccessfulCard;
